// import store from '../store';
import Request from './request'
// import snackbar from '@/plugins/snackbar';
// import i18n from '@/i18n';



async function fetchDetail(data) {
  return Request('get', "api/receipt/view",data);
}

export default {
  fetchDetail,
}